import React from 'react';
import classes from './WhatsNewPage.module.scss';
import { CenteredContentLayout } from '../../../components/containers/CenteredContentLayout';
import emptyNews from '../../../assets/images/emptyNews.svg';
import { EmptyPlaceholder } from '../../../components/containers/EmptyPlaceholder';
import { Panel } from '../../../components/containers/Panel';
import { GetAllSiteNewsQuery } from '../../../models/graphql';
import { ApolloError } from '@apollo/client';
import { BoxNotification } from '../../../components/containers/BoxNotification';
import { remapApolloErrors } from '../../../helpers/remapApolloErrors';
import { WhatsNewItem } from '../WhatsNewItem';

export type WhatsNewPageViewProps = {
  title: string;
  loading: boolean;
  data?: GetAllSiteNewsQuery;
  error?: ApolloError;
};

export const WhatsNewPageView = (props: WhatsNewPageViewProps): JSX.Element => {
  const { title, loading, data, error } = props;

  return (
    <div className={classes.WhatsNewPage}>
      <CenteredContentLayout headerTitle={title} loading={loading} hasSidebar={false}>
        {error ? (
          <BoxNotification type={'error'}>{remapApolloErrors(error)}</BoxNotification>
        ) : data ? (
          data.allSiteNews.length ? (
            <Panel customClass={classes.Panel}>
              {data.allSiteNews.map((item, index, { length }) => (
                <WhatsNewItem
                  text={item.text}
                  date={item.date}
                  title={item.title}
                  key={`what'snew_item_${index}_${length}`}
                  excludeHr={length === index + 1}
                />
              ))}
            </Panel>
          ) : (
            <EmptyPlaceholder title={'No News, Big Plans!'} image={emptyNews}>
              <p>
                While there&apos;s nothing new to report right now, we&apos;re gearing up for some exciting
                developments. Keep an eye on this page!
              </p>
            </EmptyPlaceholder>
          )
        ) : null}
      </CenteredContentLayout>
    </div>
  );
};
